/* unplugin-vue-components disabled */import { render } from "./SpocCourse.vue?vue&type=template&id=cdba02c4&scoped=true"
import script from "./SpocCourse.vue?vue&type=script&lang=js"
export * from "./SpocCourse.vue?vue&type=script&lang=js"

import "./SpocCourse.vue?vue&type=style&index=0&id=cdba02c4&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户广西-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdba02c4"]])

export default __exports__